import { render, staticRenderFns } from "./BriqTreeView.vue?vue&type=template&id=65cbbc4d&scoped=true&lang=pug&"
import script from "./BriqTreeView.vue?vue&type=script&lang=js&"
export * from "./BriqTreeView.vue?vue&type=script&lang=js&"
import style0 from "./BriqTreeView.vue?vue&type=style&index=0&id=65cbbc4d&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cbbc4d",
  null
  
)

export default component.exports